import "../../../../assets/css/Wyswig.sass";
import "../../../../assets/css/Editor.sass";
import { useState, useEffect } from "react";
import { fetchData, addIndexes, formatDates } from "../../../../assets/js/functions";

export const LoaderContainer = ({ loadPost, title, setTitle }) => {
  const [posts, setPosts] = useState([]);
  const [options, setOptions] = useState();

  //Fill the select
  useEffect(() => {
    if (posts.length > 0) {
      setOptions(posts.map((post) => [post.title, post._id]));
      if (!title) {
        setTitle(posts[0].title);
      }
    }
  }, [posts, title, setTitle]);

  //Data fetching
  useEffect(() => {
    const processData = (data) => {
      addIndexes(data);
      formatDates(data);
      setPosts(data);
    };

    const url = "db/posts";
    fetchData(url, processData);
  }, []);

  //Container rendering
  return (
    <div>
      <div>
        <select
          id="editor-select"
          onChange={(e) => {
            loadPost(e);
            setTitle(e.target.selectedOptions[0].dataset.title);
          }}
        >
          {options
            ? options.map((opt, idx) => (
                <option key={idx} value={opt[1]} data-id={opt[1]} data-title={opt[0]}>
                  {opt[0]}
                </option>
              ))
            : ""}
        </select>
      </div>
      <div id="editor-input">
        <label htmlFor="post-title">Title:</label>
        <input id="post-title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
      </div>
    </div>
  );
};
